import { useRef } from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import BlockContent from "../../blocks/block-content";
import CoreContainer from "../../core-container";
import TypedText from "../../typed-text";
import Picture from "components/picture";
import { UilAngleDown as ArrowDownIcon } from "@iconscout/react-unicons";
import "./hero.css";

const Hero = ({ data = {} }) => {
  const { content, bgType, photos, textPosition, bgGradient, isTop, typedText, theme } = data;
  const textAlign = textPosition?.textPosition;
  const addNegative = isTop?.isTop === "yes";
  const ref = useRef(null);

  return (
    <section
      className={cx(
        "hero-module relative mx-auto flex h-[540px] flex-col justify-center overflow-hidden text-center sm:h-[740px]",
        theme?.value ? `theme theme--${theme.value}` : null,
        textAlign ? `text-position--${textAlign}` : null,
        { ["-mt-20"]: addNegative }
      )}
      ref={ref}
    >
      {bgType === "photo" && (
        <div className="absolute h-[540px] w-full sm:h-[740px]">
          {photos?.desktopPhoto && (
            <div className="hidden h-full w-full sm:block">
              <Picture
                picture={{ image: photos.desktopPhoto }}
                layout="fill"
                objectFit="cover"
                priority={true}
                placeholder="blur"
              />
            </div>
          )}
          {photos?.mobilePhoto && (
            <div className="block h-full w-full sm:hidden">
              <Picture
                picture={{ image: photos.mobilePhoto }}
                layout="fill"
                objectFit="cover"
                priority={true}
                placeholder="blur"
              />
            </div>
          )}
          <div className={cx("hero--cover", bgGradient === "white" ? "hero--cover--bg-gradient-white" : null)}></div>
        </div>
      )}
      {content && (
        <CoreContainer className="z-[1] text-white">
          <div
            className={cx("max-w-2xl whitespace-pre-wrap px-14 pt-10 sm:mb-16 md:px-20  ", {
              ["text-center md:text-left"]: textAlign === "left",
              ["md:text-right"]: textAlign === "right",
              ["mx-auto max-w-5xl md:text-center"]: textAlign === "center",
            })}
          >
            {typedText?.strings?.length > 0 && (
              <TypedText
                strings={typedText.strings}
                leftText={typedText.leftText}
                rightText={typedText.rightText}
                typedText={typedText.typedText}
                textPosition={textPosition?.textPosition}
              />
            )}
            <BlockContent blocks={content} />
          </div>
        </CoreContainer>
      )}
      <button
        onClick={() => {
          const elementPosition = ref.current.getBoundingClientRect().top + window.scrollY;

          window.scrollTo({
            behavior: "smooth",
            top: elementPosition + ref.current.clientHeight - 60,
            left: 0,
          });
        }}
        className="absolute left-0 right-0 bottom-[22px] z-10 mx-auto hidden h-12 w-12 animate-bouncing-arrow items-center justify-center rounded-full bg-[#E5B04F] md:flex"
      >
        <ArrowDownIcon className="h-11 w-11 text-neutral-100" />
      </button>
    </section>
  );
};

Hero.propTypes = {
  data: PropTypes.shape({
    theme: PropTypes.shape({
      value: PropTypes.oneOf(["light", "soft", "dark"]),
    }),
    isTop: PropTypes.shape({
      isTop: PropTypes.string,
    }),
    textPosition: PropTypes.shape({
      textPosition: PropTypes.string,
    }),
    typedText: PropTypes.shape({
      leftText: PropTypes.string,
      rightText: PropTypes.string,
      typedText: PropTypes.string,
      strings: PropTypes.arrayOf(PropTypes.string),
    }),
  }),
};

export default Hero;
